export const flightSearchSecret = 'abcd';
